import { configureStore } from '@reduxjs/toolkit'
import intlReducer from './lng'

const store = configureStore({
  reducer: {
    lng: intlReducer,
  },
})

export default store
